import store from "./store/store"
import { onSessionEnd } from "@/auth/session"
import { resetCrispSession } from "@/services/CrispChatService"
import { shutdownIntercom } from "@/services/IntercomService"
import { resetPostHogUser } from "@/services/PostHogService"

// Everything that has to be undone when a session ends, beyond wiping storage.
// Registered once from main.js so it runs on every path that ends a session —
// not only the two that dispatch Security/logout.
//
// This lives outside src/auth/ on purpose. src/auth/keycloak.js is what calls
// clearSession(), so importing the store from there would close the loop
// keycloak -> store -> modules -> security/actions -> keycloak. Registering from
// the app layer keeps src/auth/session.js free of imports entirely.
export const registerSessionTeardown = () => {
  onSessionEnd(() => {
    // All three are internally guarded, so they are no-ops when the widget was
    // never booted — which is the case when a session ends during boot.
    resetCrispSession()
    shutdownIntercom()
    resetPostHogUser()

    // Drop the previous user's data rather than relying on the logout redirect
    // to tear the page down. Every initialState() factory returns a fully shaped
    // object, so getters reading account.rights or user.basic_info stay safe if
    // anything re-renders before the navigation lands.
    store.dispatch("Account/resetAccount")
    store.commit("Profile/reset")
    store.commit("ProfileStations/reset")

    // Uploads outlive an account switch, so resetAccount leaves them running.
    // They must not outlive the user who started them.
    store.dispatch("Library/cancelUpload")
    store.dispatch("EpisodeUploads/cancelAllUploads")
    store.dispatch("PodcastImportRefresh/cancelAllRefreshes")
  })
}
